import { useGeocodingService } from '@ubilabs/google-maps-react-hooks';
import _ from 'lodash';
import { useEffect } from 'react';

import { useClinics } from '../../hooks/useClinics';
import { sortedClinicsWithDistance } from '../../store/selectors';
import { useLocatorStore } from '../../store/useLocatorStore';

export function useHandleGeocodeCurrentLocation() {
  const geocoder = useGeocodingService();
  const {
    currentLocation,
    setSearchInput,
    searchInput,
    setVisibleClinics,
    setRadius,
    shouldGeoLocate,
    setShouldGeoLocate,
    setMapViewBounds,
  } = useLocatorStore((state) => state);

  const { clinics } = useClinics();
  const clinicsWithDistance = useLocatorStore((state) => sortedClinicsWithDistance(state, clinics));

  const closestClinics = _.sortBy(clinicsWithDistance, 'distanceInMetres').slice(0, 10);

  useEffect(() => {
    if (currentLocation && shouldGeoLocate && !searchInput.length && clinicsWithDistance.length) {
      setShouldGeoLocate(false);

      geocoder?.geocode(
        { location: currentLocation },
        (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
          if (status !== 'OK' || !results) {
            // eslint-disable-next-line no-console
            console.error(`Geocoding was not successful for the following reason: ${status}`);

            return;
          }

          const position = results[0].geometry.location;
          const placeResult = results[0];

          if (!position) {
            return;
          }

          // Extract less specific address from address_components
          const lessSpecificComponent = placeResult.address_components.find((component) =>
            component.types.includes('sublocality')
          );

          const lessSpecificAddress = lessSpecificComponent
            ? lessSpecificComponent.long_name
            : placeResult.formatted_address;

          setSearchInput(lessSpecificAddress);

          const roundedRadius = Math.ceil(closestClinics[9].distanceInMetres! / 1000);
          const bounds = new google.maps.LatLngBounds();

          bounds.extend(currentLocation);
          setMapViewBounds(bounds);
          setRadius(roundedRadius);
          setVisibleClinics(closestClinics);
        }
      );
    }
  }, [searchInput, currentLocation, shouldGeoLocate, clinicsWithDistance]);
}
